import React from 'react';
import { Table } from 'reactstrap';
import PropTypes from 'prop-types';
import { generateFullName } from 'utils/badgeHelpers';

const Representatives = ({
  clientSuccessOnboarding,
  clientSuccessScaling,
  salesRepresentative,
}) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Representatives</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">Client Success Onboarding:</span>
          <span>
            {clientSuccessOnboarding &&
              generateFullName(
                clientSuccessOnboarding.title,
                clientSuccessOnboarding.firstName,
                clientSuccessOnboarding.middleName,
                clientSuccessOnboarding.lastName,
              )}
            {clientSuccessOnboarding?.status === 'inactive' && (
              <>
                <br />
                <span className="error-message">
                  *representative is currently inactive
                </span>
              </>
            )}
          </span>
          <span className="subheader">Client Success Scaling:</span>
          <span>
            {clientSuccessScaling &&
              generateFullName(
                clientSuccessScaling.title,
                clientSuccessScaling.firstName,
                clientSuccessScaling.middleName,
                clientSuccessScaling.lastName,
              )}
            {clientSuccessScaling?.status === 'inactive' && (
              <>
                <br />
                <span className="error-message">
                  *representative is currently inactive
                </span>
              </>
            )}
          </span>
          <span className="subheader">Sales:</span>
          <span className="text-transform-none">
            {salesRepresentative &&
              generateFullName(
                salesRepresentative.title,
                salesRepresentative.firstName,
                salesRepresentative.middleName,
                salesRepresentative.lastName,
              )}
            {salesRepresentative?.status === 'inactive' && (
              <>
                <br />
                <span className="error-message">
                  *representative is currently inactive
                </span>
              </>
            )}
          </span>
        </td>
      </tr>
    </tbody>
  </Table>
);

Representatives.propTypes = {
  clientSuccessOnboarding: PropTypes.object,
  clientSuccessScaling: PropTypes.object,
  salesRepresentative: PropTypes.object,
};

export default Representatives;
